import { startTransition } from 'react'
import { derived, writable } from '@shared/lib/store'

export const visibleClausesStore = writable(new Set<number>())
export const handleClauseVisibilityChange = function ({ index, inView }: { index: number, inView: boolean }): void {
  startTransition(() => {
    visibleClausesStore.update((current) => {
      if (inView) {
        current.add(index)
      } else {
        if (!current.has(index)) {
          // If the index which is updated is already not in the Set, bails out early
          // Optimization for the first render, where all Clauses report a change events, but almost none of them are visible.
          return current
        }
        current.delete(index)
      }
      return new Set(current)
    })
  })
}

export const isPageScrolledStore = writable(false)
export const isSidebarScrolledStore = writable(false)

export const highlightedClauseStore = derived([visibleClausesStore, isPageScrolledStore], ([visibleClauses, isScrolled]) => {
  if (typeof window === 'undefined') return -1
  if (!isScrolled) return -1

  const sorted = Array
    .from(visibleClauses.entries())
    .sort(([indexA], [indexB]) => {
      return indexA < indexB ? -1 : 1
    })

  return sorted[0]?.[0] ?? -1
})
